import type { WidgetOffer } from "@intelligems/ig-types";

export const getUnitDiscount = (
  basePrice: number,
  unit: number,
  offer: WidgetOffer
): number => {
  let totalUnit: number;
  if (offer.unitType === "dollar") {
    totalUnit = unit * basePrice;
  } else {
    totalUnit = unit;
  }

  for (const tier of offer.tiers) {
    if (totalUnit >= tier.minimumUnits && totalUnit <= tier.maximumUnits) {
      return tier.unitDiscount;
    }
  }
  return 0;
};

const fontWeightMappings: { [key: string]: number } = {
  light: 400,
  regular: 500,
  medium: 600,
  bold: 700,
};

export const getFontWeightAndStyle = (
  fontStyleInput: string
): { fontWeight: number; fontStyle: string } => {
  let fontWeight = "medium";
  let fontStyle = "none";

  fontStyleInput.split("_").forEach((style, index) => {
    if (index === 0) {
      fontWeight = style;
    } else if (index === 1) {
      fontStyle = style;
    }
  });

  return { fontWeight: fontWeightMappings[fontWeight], fontStyle };
};
